export default {
  ThisDay: "Hôm nay",
  ThisWeek: "Tuần này",
  FirstWeekToPresent:"Đầu tuần tới hiện tại",
  ThisMonth: "Tháng này",
  Last30Days: "30 ngày gần nhất",
  FirstMonthToPresent:"Đầu tháng đến hiện tại",
  ThisQuarter: "Quý này",
  FirstQuarterToPresent:"Đầu quý đến hiện tại",
  ThisYear: "Năm nay",
  FirstYearToPresent:"Đầu năm đến hiện tại",
  SixFirstMonth:'Sáu tháng đầu năm',
  SixLastMonth: "Sáu tháng cuối năm",
  //Các tháng trong năm
  January: "Tháng 1",
  February: "Tháng 2",
  March: "Tháng 3",
  April: "Tháng 4",
  May: "Tháng 5",
  June: "Tháng 6",
  July: "Tháng 7",
  August: "Tháng 8",
  September: "Tháng 9",
  October: "Tháng 10",
  November: "Tháng 11",
  December: "Tháng 12",

  //Quý (DNThang sửa từ ký tự La mã về thành số nguyên)
  FiscalI: "Quý 1", //Qúy 1
  FiscalII: "Quý 2",
  FiscalIII: "Quý 3",
  FiscalIV: "Quý 4",


  Yesterday: "Hôm qua",
  LastWeek: "Tuần trước",
  LastMonth: "Tháng trước",
  LastQuarter: "Quý trước",
  LastYear: "Năm trước",


  Tomorrow: "Ngày mai",
  NextWeek: "Tuần sau",
  NextMonth: "Tháng sau",
  NextQuarter:"Quý sau",
  NextYear:"Năm sau",
  // FourLastWeek: 41,
  // ThreeLastYear: 85,
  Custom: "Tùy chọn",
  Last7Day: "7 ngày gần nhất",
  Other: "Tùy chọn",
  
  DateStringFormat: '{0}/{1}/{2}',
  DateFormat: 'Ngày {0} tháng {1} năm {2}',
  YearFormat: 'Năm {0}',
  MonthFormat: 'Tháng {0} năm {1}',
  QuarterFormat: 'Quý {0} năm {1}',
  FromDateToDateFormat: 'Từ {0} đến {1}',
	FullDateFormat: 'DD/MM/YYYY',
  ReportDateFormat: 'Ngày {0}',
  ToDateFormat: 'Đến {0}',

  Month: 'Tháng',
  Quarter: 'Quý',
  Year: 'Năm',
}
